import React, { useEffect, useState } from "react";
import { logger } from "@origin-digital/reporting-client";
import { isExperienceEnabled } from "@origin-digital/features";
import { useAppContext } from "../../AppContext";
import { ILink } from "./SubCategoryList.types";
import { SubCategoryList } from "./SubCategoryList";
import { fetchFAQLinks } from "./subcategoryList.helper";
import {
  shouldTransformArticles,
  transformArticles,
} from "./OE518ListTransformer";

interface IProps {
  labelId?: string;
  categorySlug: string;
  subcategorySlug: string;
  max?: number;
  showMoreLink?: ILink;
  "data-id"?: string;
}

export const SubCategoryListController = ({
  labelId,
  categorySlug,
  subcategorySlug,
  max = 0,
  showMoreLink,
  "data-id": dataId,
}: IProps) => {
  const [articles, setArticles] = useState<ILink[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const {
    config: { bold360kb, bold360account, bold360host, ttl },
    customerContext,
    visitorToken,
  } = useAppContext();

  useEffect(() => {
    if (!labelId) return;

    fetchFAQLinks(
      {
        config: { host: bold360host, account: bold360account, kb: bold360kb },
        labelId,
        categorySlug,
        subcategorySlug,
        customerContext,
        visitorToken,
      },
      { ttl }
    )
      .then((links: ILink[]) => {
        setArticles(links);
        setLoading(false);
      })
      .catch((error) => {
        logger.error(`Failed fetching faqs - ${dataId}`, error);
      });
  }, [labelId]);

  // BEGIN OE-518 A/B Test code
  const isArticlesExperiment = isExperienceEnabled("OE-518-mbox");
  const shouldRenderTransformedArticles =
    isArticlesExperiment && shouldTransformArticles(subcategorySlug);

  if (shouldRenderTransformedArticles) {
    return (
      <SubCategoryList
        articles={transformArticles(subcategorySlug, articles)}
        max={0}
        loading={loading}
        data-id={dataId}
      />
    );
  }
  // END OE-158 A/B Test code

  return (
    <SubCategoryList
      articles={articles}
      max={max}
      showMoreLink={showMoreLink}
      loading={loading}
      data-id={dataId}
    />
  );
};
